"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnifiedSkeleton = exports.ImageSkeleton = exports.ButtonSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _ProductImage = require("../ProductImage");
const UnifiedSkeleton = exports.UnifiedSkeleton = (0, _mui.styled)(_mui.Skeleton)({
  transform: 'none'
});
const ImageSkeleton = exports.ImageSkeleton = (0, _mui.styled)(UnifiedSkeleton)({
  width: _ProductImage.PRODUCT_IMAGE_SIZE,
  height: _ProductImage.PRODUCT_IMAGE_WRAPPER_HEIGHT,
  minWidth: _ProductImage.PRODUCT_IMAGE_SIZE
});
const ButtonSkeleton = exports.ButtonSkeleton = (0, _mui.styled)(UnifiedSkeleton)(({
  theme
}) => ({
  width: 35,
  height: 35,
  ...(theme.responsiveLayout && {
    [theme.breakpoints.up('sm')]: {
      width: 45,
      height: 45
    }
  })
}));
//# sourceMappingURL=styles.js.map